<template>
    <form @submit.prevent="submit" ref="form">
        <text-input v-model="form.name" :errors="$page.props.errors.name" class="mb-3" label="Naam" disabled />

        <text-input v-model="form.greenness_label" :errors="$page.props.errors.greenness_label" class="mb-3" label="Greenness Label" type="number" />

        <label for="">Toon in footer</label>
        <select
            v-model="form.show_in_footer"
            class="form-input block appearance-none w-full py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
        >
            <option :value="false">Nee</option>
            <option :value="true">Ja</option>
        </select>
        <div v-if="$page.props.errors.show_in_footer" class="form-error">{{ $page.props.errors.show_in_footer[0] }}</div>


        <text-input v-model="form.pitch" :errors="$page.props.errors.pitch" class="mt-3 mb-3" label="One line pitch" type="text" />
        <textarea-input v-model="form.waarom" :errors="$page.props.errors.waarom" class="mb-3" label="Waarom" />
        <textarea-input v-model="form.product" :errors="$page.props.errors.product" class="mb-3" label="Product/service" />
        <!-- <wysiwyg :value="form.description" v-model="form.description" :error="$page.props.errors.description" label="Omschrijving"></wysiwyg> -->

        <div class="mt-5 mb-3">
            <file-input v-model="form.image" :errors="$page.props.errors.image" class="w-full lg:w-1/2" type="file" accept="image/*" label="Logo" :data-preview-img="company.logo" />

            <a :href="`https://www.google.com/search?q=${company.name}+logo&tbm=isch`" target="_blank" class="text-sm">
                google image search<i class="fad fa-external-link ml-1"></i>
            </a>
        </div>

        <div>
            <h2 class="font-bold text-2xl mt-6 mb-5 border-t pt-5">SEO</h2>
            <textarea-input v-model="form.seo_description" :errors="$page.props.errors.seo_description" class="mb-3" label="Meta description" />
            <wysiwyg :value="form.seotext1" v-model="form.seotext1" :error="$page.props.errors.seotext1" label="SEO tekst boven"></wysiwyg>
            <wysiwyg :value="form.seotext2" v-model="form.seotext2" :error="$page.props.errors.seotext2" label="SEO tekst beneden"></wysiwyg>
        </div>

        <button type="submit" class="mt-5 text-white bg-teal-700 px-5 py-3 rounded inline-block hover:bg-teal-800 focus:bg-teal-800">
            <i class="fal mr-1" :class="loading == 'submit' ? 'fa-spinner fa-spin' : 'fa-save'"></i>Opslaan
        </button>
    </form>
</template>

<script>
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Layout from "@/admin/Shared/Layout";
import TextInput from "@/admin/Shared/TextInput";
import TextareaInput from "@/admin/Shared/TextareaInput";
import FileInput from "@/admin/Shared/FileInput";
import wysiwyg from "@/admin/Shared/WYSIWYG";

export default {
    components: {
        TextInput,
        TextareaInput,
        FileInput,
        wysiwyg,
    },

    mixins: [Helpers],

    props: {
        dataLoading: false,
        company: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    watch: {
        dataLoading: function(loading) {
            this.loading = loading;
        }
    },

    data() {
        return {
            form: {
                name: this.company.name || "",
                image: this.company.image || null,
                description: this.company.description || "",
                pitch: this.company.pitch || "",
                waarom: this.company.waarom || "",
                product: this.company.product || "",
                seotext1: this.company.seotext1 || "",
                seotext2: this.company.seotext2 || "",
                seo_description: this.company.seo_description || "",
                show_in_footer: this.company.show_in_footer,
                greenness_label: this.company.greenness_label
            }
        };
    },

    methods: {
        submit() {
            var data = new FormData();

            data.append("name", this.form.name);
            data.append("description", this.form.description || "");
            data.append("pitch", this.form.pitch || "");
            data.append("waarom", this.form.waarom || "");
            data.append("product", this.form.product || "");
            data.append("seotext1", this.form.seotext1 || "");
            data.append("seotext2", this.form.seotext2 || "");
            data.append("seo_description", this.form.seo_description || "");
            data.append("image", this.form.image || "");
            data.append("show_in_footer", this.form.show_in_footer ? 1 : 0);
            data.append("greenness_label", this.form.greenness_label || '');

            this.$emit("submit", data);
        }
    }
};
</script>
